import React from 'react';
import { useTranslation } from 'react-i18next';

import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';

import useStyles from './styles';

function ToggleCondition({
  condition,
  setCondition,
}) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container component="label" alignItems="center" justify="flex-end" direction="row">
      <Grid item>{t('filter-and')}</Grid>
      <Grid item>
        <Switch
          classes={classes}
          checked={condition === 'OR'}
          onChange={() => setCondition(condition === 'OR' ? 'AND' : 'OR')}
        />
      </Grid>
      <Grid item>{t('filter-or')}</Grid>
    </Grid>
  );
}

export default React.memo(
  ToggleCondition,
  (prevProps, nextProps) => prevProps.condition === nextProps.condition
);
